import Component from "../../../../js/assets/component.js"
import ImageLoader from "../../../../js/assets/image_loader.js"

class SlideShowItem extends Component {
  constructor(el){
    super(el);
  }

  data(){
    return {
      "src" : null,
      "loaded" : false
    }
  }

  changed(){
    return {
      "src" : (val)=>{
        this.noChange('src')
        // this.loadImage(val)
      },
      "loaded" : (val)=>{
        if (val === true) {
          // console.log(this.$data.src + " is loaded!")
          this.noChange('loaded')
          this.$loading.removeClass("-loading")
          this.$loading.addClass("-inActive")
          this.$el.addClass("-loaded")
          this.imageLoader = null
          delete this.imageLoader
        }
      }
    }
  }

  loadImage(){
    if (!this.imageLoader){
      return
    }
    this.imageLoader.register(this.$data.src)
    //load (use cache)
    this.imageLoader.load(true)
  }

  activate(){
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
  }

  mounted(){
    var self = this

    //image
    this.$img = this.$el.find("img")
    if(this.$img.length === 0){
      return
    }

    //show loading
    this.$loading = this.$el.find(".loading")
    this.$loading.addClass("-loading")

    //imageLoader
    this.imageLoader = new ImageLoader()
    this.imageLoader.addEventListener("loaded", loadedHandler)

    function loadedHandler() {
      self.imageLoader.removeEventListener("loaded", loadedHandler)
      self.$data.loaded = true
    }

    //set src
    this.$data.src = this.$img.attr("src")

  }
}

export default SlideShowItem
